<template>
    <popup-modal ref="popup">
        <h2 style="margin-top: 0" v-html="title"></h2>
        <p class="text-center" v-html="message"></p>
        <div class="btns">
            <button type="button" class="border-0 cancel-btn bg-primary text-white w-50" @click="_cancel">{{ cancelButton }}</button>
            <button type="button" class="w-50 border-0 ok-btn" @click="_confirm">{{ okButton }}</button>
        </div>
    </popup-modal>
</template>

<script>
import PopupModal from '@/components/popupmodal.vue';

export default {
    name: 'confirmDialog',

    components: { PopupModal },

    data: () => ({
        // Parameters that change depending on the type of dialogue
        title: undefined,
        message: undefined, // Main text content
        okButton: undefined, // Text for confirm button; leave it empty because we don't know what we're using it for
        cancelButton: 'Go Back', // text for cancel button
        
        // Private variables
        resolvePromise: undefined,
        rejectPromise: undefined,
    }),

    methods: {
        show(opts = {}) {
            this.title = opts.title
            this.message = opts.message
            this.okButton = opts.okButton
            if (opts.cancelButton) {
                this.cancelButton = opts.cancelButton
            }
            // Once we set our config, we tell the popup modal to open
            this.$refs.popup.open()
            // Return promise so the caller can get results
            return new Promise((resolve, reject) => {
                this.resolvePromise = resolve
                this.rejectPromise = reject
            })
        },

        _confirm() {
            this.$refs.popup.close()
            this.resolvePromise(true)
        },

        _cancel() {
            this.$refs.popup.close()
            this.resolvePromise(false)
            // Or you can throw an error
            // this.rejectPromise(new Error('User canceled the dialogue'))
        },
    },
}
</script>

<style scoped>
.btns {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    border-top: 1px solid #1e73b2;
}

.ok-btn {
    padding: 0.5em 1em;
    background-color: #bb3e10;
    color: #f1f3ac;
    font-weight: bold;
    font-size: 16px;
    text-transform: uppercase;
    cursor: pointer;

}

.cancel-btn {
    padding: 0.5em 1em;
    font-weight: bold;
    font-size: 16px;
    text-transform: uppercase;
    cursor: pointer;
}
</style>
